import React, { useContext } from 'react';
import { BookerStateContext } from '../../hooks/useRuntimeCalBookingState';
import {
    EventServerModel,
    ServiceProviderStage,
    WidgetStep,
} from '../../types';
import BookerStep from './BookerStep/BookerStep';
import SelectEventsStep from './SelectEventsStep/SelectEventStep';
import StaffMemberSelectionStep from './SelectStaffMemberStep';

interface CurrentStepComponentProps {
    events: EventServerModel[] | null;
    serviceProviderStage: ServiceProviderStage;
}
const STEP_COMPONENTS = {
    [WidgetStep.STAFF_MEMBER_SELECTION]: StaffMemberSelectionStep,
    [WidgetStep.EVENT_SELECTION]: SelectEventsStep,
    [WidgetStep.BOOKER]: BookerStep,
};

function CurrentStepComponent({
    events,
    serviceProviderStage,
}: CurrentStepComponentProps) {
    const [state] = useContext(BookerStateContext);

    const isMultipleEvents = events && events.length > 1;
    const currentEventSlug = state.eventSlug;
    const isMultipleEventsNoEventSlug = isMultipleEvents && !currentEventSlug;
    const isStaffMemberSelection =
        state.eventSelection && state.eventSelection.hosts.length > 1;
    const isStaffMemberSelectionStage =
        serviceProviderStage.isStageShown &&
        isStaffMemberSelection &&
        !state.selectedHost;

    const currentStep = isMultipleEventsNoEventSlug
        ? WidgetStep.EVENT_SELECTION
        : isStaffMemberSelectionStage
        ? WidgetStep.STAFF_MEMBER_SELECTION
        : WidgetStep.BOOKER;

    const StepComponent = STEP_COMPONENTS[currentStep];

    return <StepComponent />;
}

export default CurrentStepComponent;
